import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { State } from 'src/app/reducers';
import { loadGoalCategories, loadGoals } from '../../../store/goal/goal.actions';
import { User } from 'src/app/store/auth/auth.models';
import { takeUntil } from 'rxjs/operators';
import { Goal, GoalCategory } from 'src/app/store/goal/goal.models';
import {Form, FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-goals',
  templateUrl: './goals.component.html',
  styleUrls: ['./goals.component.scss'],
})
export class GoalsComponent implements OnInit {
  private destroyer$: Subject<any> = new Subject();

  // goal categories
  loadingGoalcategories$: Observable<boolean>;
  loadingGoalCategoriesError$: Observable<string>;
  goalCategories$: Observable<GoalCategory[]>;

  loadingGoals$: Observable<boolean>;
  loadingGoalsError$: Observable<string>;
  userGoals: Goal[];
  currentUser: User;
  isLinear = false;
  addGoalForm: FormGroup;

  checked = false;
  indeterminate = false;
  labelPosition: 'before' | 'after' = 'after';
  disabled = false;
  panelOpenState = false;

  constructor(private store: Store<State>, private fb: FormBuilder) {
    // load all the goal categories
    this.loadingGoalcategories$ = this.store.select(state => state.goals.loadingGoalCategories);
    this.loadingGoalCategoriesError$ = this.store.select(state => state.goals.loadingGoalCategoriesError);
    this.goalCategories$ = this.store.select(state => state.goals.goalCategories);
    this.store.dispatch(loadGoalCategories());
    this.store.select((state) => state.auth.authenticatedUser).pipe(takeUntil(this.destroyer$)).subscribe((user) => this.currentUser = user);

  }


  ngOnInit(): void {
  }

  goal(): FormArray {
      return this.addGoalForm.get('allGoals') as FormArray;
  }

  newGoal(): FormGroup {
    return this.fb.group({
      goalInput: ['', [Validators.required]]
    });
  }

  addGoal(): void {
    this.goal().push(this.newGoal());
  }


  getUserFullName(): string {
    return this.currentUser ? `${this.currentUser.given_name} ${this.currentUser.family_name}` : '';
  }


  ngOnDestroy(): void {
    this.destroyer$.next(false);
    this.destroyer$.complete();
  }
}
